/**
 * duzen.tsx
 *
 * NE İŞE YARAR : Kimlik doğrulama ekranlarının ortak çerçevesi — ortalanmış tek kart
 * KAYNAK SPEC  : 15-arayuz-standardi.md §15 (kimlik ekranları) · §4.3 (boşluk)
 *                §4.4 (köşe, gölge, çizgi) · §13 (erişilebilirlik — başlık sırası)
 * BAĞLI OLDUĞU : @mantine/core · src/metin
 * KULLANAN     : src/ekran/kimlik/* — beş ekranın hepsi
 * DİKKAT       : 1) BU EKRANLARDA KABUK YOKTUR (`15` §5). Üst çubuk, menü ve scope
 *                   seçici oturum açıldıktan sonra anlamlıdır; henüz kim olduğu
 *                   bilinmeyen bir kullanıcıya rolüne göre kurulmuş bir menü
 *                   gösterilemez.
 *                2) KART GÖLGE ALMAZ (`15` §4.4). Gölge yalnız yüzen katmandadır;
 *                   ayrım çizgiyle yapılır. Tema `xs`/`sm` gölgelerini zaten sıfırladı,
 *                   burada `withBorder` o kararın karşılığıdır.
 *                3) BAŞLIK HER EKRANDA `h1`DİR. Ekran okuyucu sayfanın ne olduğunu
 *                   başlık sırasından anlar; kimlik ekranları tek konuludur ve ikinci
 *                   bir `h1` olamaz (`15` §13).
 *                4) GENİŞLİK SABİTTİR. Form alanları ekran genişliğine yayılsaydı geniş
 *                   bir monitörde tek satırlık bir parola kutusu ekranı boydan boya
 *                   geçer ve okuma mesafesi bozulurdu.
 * SON GÜNCELLEME: 2026-08-31 03:30:00
 */
import { Box, Card, Center, Stack, Text, Title } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';

import { metin } from '../../metin';

export function KimlikDuzeni({
  baslik,
  aciklama,
  children,
  altBilgi,
}: {
  baslik: string;
  // `exactOptionalPropertyTypes` açık: `?` tek başına *"undefined atanabilir"* demek
  // değildir. Açıkça yazılmasaydı, koşula bağlı bir açıklama geçen her çağrı derlemede
  // reddedilirdi.
  aciklama?: string | undefined;
  children: ReactNode;
  altBilgi?: ReactNode | undefined;
}): ReactElement {
  return (
    <Center mih="100vh" p="lg" bg="notr.0">
      <Stack gap="lg" w="100%" maw={420}>
        <Box ta="center">
          <Text size="sm" c="notr.6">
            {metin('ortak.uygulamaAdi')}
          </Text>
        </Box>

        <Card withBorder radius="sm" padding="xl" bg="white">
          <Stack gap="lg">
            <Box>
              {/* Başlıktaki not 3 — her kimlik ekranında tek `h1`. */}
              <Title order={1} size="h3">
                {baslik}
              </Title>
              {aciklama === undefined ? null : (
                <Text size="sm" c="notr.7" mt="xs">
                  {aciklama}
                </Text>
              )}
            </Box>

            {children}
          </Stack>
        </Card>

        {altBilgi === undefined ? null : <Box ta="center">{altBilgi}</Box>}
      </Stack>
    </Center>
  );
}
